import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Menu, Avatar } from 'antd';
import { getUserFullName } from '../../utils/common';

class UserItem extends Component {
  render() {
    const { user } = this.props;
    const { staticContext, ...rest } = this.props;

    var isActive = this.props.location.pathname === `/${user.identifier}`;
    var className = isActive ? 'ant-menu-item-selected' : '';

    return (
      <Menu.Item className={className} {...rest}>
        <Link to={`/${user.identifier}`}>
          <Avatar
            alt={getUserFullName(user)}
            style={{ backgroundColor: '#87d068' }}
            src={user.photoUrl}
            className="anticon"
          >
            {user.identifier[0].toUpperCase()}
          </Avatar>
          <span className="nav-text">{getUserFullName(user)}</span>
        </Link>
      </Menu.Item>
    );
  }
}

export default withRouter(UserItem);



// WEBPACK FOOTER //
// ./src/modules/Users/UserListItem.js